// project imports
import * as actionTypes from "./actions";

export const initialState = {
  collection: {},
};

const returnCollectionReducer = (state = initialState, action) => {
  let value;
  switch (action.type) {
    case actionTypes.RETURN_COLLECTION:
      value = action.value;
      return {
        ...state,
        value,
      };
    default:
      return state;
  }
};

export default returnCollectionReducer;
